import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LoaderService } from 'src/app/services/loader.service';
import { ToastService } from 'src/app/services/toast.service';
import { DataService } from 'src/app/services/data.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { throwError } from 'rxjs';
import { PlatformService } from 'src/app/platform.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
})
export class ForgotPasswordPage  {
  errors=[]
  forgotPasswordForm:FormGroup= new FormGroup({})
  constructor(
    public platformSRV: PlatformService,
    private errorHandlerSRV:ErrorHandlerService,
    public dataSRV:DataService,
    private alertController: AlertController,
    private toastSRV:ToastService,
    private loaderService:LoaderService,
    private http: HttpClient,
    private fb: FormBuilder,
    public translateService: TranslateService,
    ) {
      this.forgotPasswordForm = this.fb.group({
        "email": "",
      })
    }
ionViewDidEnter(){
  this.errors=[]
  
    
    this.forgotPasswordForm = this.fb.group({
      "email": "",
    })
  
   
  
}
  
  onSendReminder() {
    this.errors=[]
    this.loaderService.showLoader(this.translateService.instant('keys.data.common.sending_email') || 'Sending email...')
     this.http.post(`${this.dataSRV.apiUrl}/api/v1/public/password/send/email`,this.forgotPasswordForm.value).subscribe({
      next:d=>{
        if(d['status']=='error'){
          this.errors.push(d['message'])
        this.loaderService.dismissLoader()
        } else if(d['status']=='success'){
          this.loaderService.dismissLoader()
          this.toastSRV.presentToast(d['message'])
        }
       
        
      },error:err=>{
        this.errorHandlerSRV.displayErrorMessage(err,false).then(response=>{
          this.errors=response['fields']
        })
        
      }
     })}
     
}
